import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import moment from "moment";

const Footer = () => {
  return (
    <Fragment>
      <footer className="border-t border-black bg-[#303031] text-white py-2 px-2">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6 items-start text-sm">
          
          {/* Kiri: Logo dan Deskripsi */}
          <div className="space-y-1">
            <img src="/assets/logo-bloom.jpg" alt="Logo FFI Flora" className="w-16 h-auto" />
            <p className="text-black text-sm max-w-xs leading-relaxed">
              {/* Tambahkan deskripsi toko jika perlu */}
            </p>
          </div>

          {/* Tengah: Navigasi */}
          <div className="flex flex-col items-center justify-center space-y-1 text-black">
            <div className="flex space-x-6">
              <Link to="/" className="hover:text-yellow-500 font-medium">Shop</Link>
              <Link to="/user/orders" className="hover:text-yellow-500 font-medium">My Orders</Link>
              <Link to="/about-us" className="hover:text-yellow-500 font-medium">About Us</Link>
            </div>
          </div>

          {/* Kanan: Sosial Media */}
          <div className="flex flex-col items-end space-y-1 text-black">
            <span className="font-semibold uppercase">Follow Us</span>
            <div className="flex space-x-4">
              
              <a
                href="https://www.instagram.com/ffi.bloom?igsh=MWhvd2p0dTIxdzBhZw%3D%3D&utm_source=qr"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src="https://cdn.iconscout.com/icon/free/png-256/instagram-1868961-1583142.png"
                  alt="Instagram"
                  className="h-5 w-5"
                />
              </a>

              <a
                href="https://www.tiktok.com/@ffibloom?_r=1&_t=ZS-99JYqGbShvg"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src="https://cdn-icons-png.flaticon.com/128/3046/3046121.png"
                  alt="TikTok"
                  className="h-6 w-6"
                />
              </a>

              <a
                href="https://wa.me/6281928539617"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src="https://cdn.iconscout.com/icon/free/png-256/tiktok-2296067-1911945.png"
                  alt="WhatsApp"
                  className="h-6 w-6"
                />
              </a>

            </div>
          </div>
        </div>
      </footer>
    </Fragment>
  );
};

export default Footer;